import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { commonStrings } from '../../../../../../core';
import { SubscriptionStrings } from '../../../../business/core';
import { ISubscriptionCard } from '../../../interfaces';

export const SubscriptionCard: React.FC<ISubscriptionCard> = ({ plan, signedPlan, handlerShowModalPayment }) => {
    const navigate = useNavigate();
    const strings = SubscriptionStrings['PTBR'].page;
    const currency_symbol = commonStrings()['PTBR'].core.currency_symbol;
    const defaultId = plan.id;
    const [selectedOptions, setSelectedOptions] = useState({ [defaultId]: 'monthly' });

    const handleSelectChange = (planId, value) => {
        setSelectedOptions({ ...selectedOptions, [planId]: value });
    };

    const renderInitialDiscount = (plan) => {
        const discount = !selectedOptions[plan.id] ? plan.monthly_discount : plan[`${selectedOptions[plan.id]}_discount`]
        return (
            <span style={{ fontSize: 20, fontWeight: "bold" }}>
                {discount}% Off
            </span>
        );
    };

    const renderInitialValue = (plan) => {
        return !selectedOptions[plan.id] ? plan.monthly : plan[selectedOptions[plan.id]]
    };

    const handleSubmit = () => {
        if (!handlerShowModalPayment) {
            navigate("/payment", {
                state: { id: plan.id, frequency: selectedOptions[plan.id] },
            });
        } else {
            handlerShowModalPayment({ id: plan.id, frequency: selectedOptions[plan.id] });
        }
    }

    return (
        <Col xs={12} sm={12} md={6} lg={4} xl={3}>
            <Card className={"py-3 mb-5"} style={plan.highlight ? { backgroundColor: '#2980b9', color: 'white', height: 480 } : { height: 480 }}>
                <Card.Body>
                    <Card.Title className={"text-center text-uppercase"}>{`${strings.plans[plan.name].title}`}</Card.Title>
                    <Card.Subtitle
                        className={"text-center mb-3"}>
                        {plan.highlight ?
                            <p>
                                <small className={"text-uppercase"}>
                                    {strings.we_recommend}
                                </small>
                            </p> :
                            <p>
                                <small className={"text-uppercase"}
                                    style={{ color: "white" }}>-</small>
                            </p>
                        }
                    </Card.Subtitle>
                    {!plan.free &&
                        <Card.Subtitle className={"mb-2 text-center"}>
                            <Form.Select
                                aria-label="Default select example"
                                value={selectedOptions[plan.id] || "monthly"}
                                onChange={(e) => handleSelectChange(plan.id, e.target.value)}
                                className={"mb-2"}
                            >
                                {signedPlan && signedPlan.signedPlanId === plan.id && signedPlan.signedPlanFrequency === "monthly"
                                    ? null
                                    : (<option value="monthly">{plan.monthly_description}</option>)}
                                {signedPlan && signedPlan.signedPlanId === plan.id && signedPlan.signedPlanFrequency === "semiannual"
                                    ? null
                                    : (<option value="semiannual">{plan.semiannual_description}</option>)}
                                {signedPlan && signedPlan.signedPlanId === plan.id && signedPlan.signedPlanFrequency === "annual"
                                    ? null
                                    : (<option value="annual">{plan.annual_description}</option>)}
                            </Form.Select>
                            {renderInitialDiscount(plan)}
                        </Card.Subtitle>
                    }
                    <Card.Text className={"text-center"}>
                        <Row>
                            <Col
                                className={"p-0"}
                            >
                                <small>{currency_symbol}</small><span style={{ fontSize: 50, fontWeight: "bold" }}>{renderInitialValue(plan)}</span>
                            </Col>
                        </Row>
                        {plan.description}
                    </Card.Text>
                    <div className="d-grid gap-2">
                        <Button
                            variant={plan.free ? "outline-dark" : "dark"}
                            onClick={() => handleSubmit()}
                            style={{ letterSpacing: -0.5 }}
                        >{strings.subscribe}</Button>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};